import { render } from "./TimelinePeriodContainer.vue?vue&type=template&id=861d178e&scoped=true"
import script from "./TimelinePeriodContainer.vue?vue&type=script&lang=js"
export * from "./TimelinePeriodContainer.vue?vue&type=script&lang=js"

import "./TimelinePeriodContainer.vue?vue&type=style&index=0&id=861d178e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861d178e"]])

export default __exports__